import { FC } from 'react'

import styled from 'styled-components'

import dayjs from 'src/Helpers/dayjs'
import { formatDate } from 'src/Constants/formatDate'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { PrimaryDottedButton } from '../Buttons/PrimaryDottedButton'

const StyledPrimaryDottedButton = styled(PrimaryDottedButton)`
  height: 48px;
`

const Container = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background-color: ${({ theme }) => theme.color.white};
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: row;
    padding: 8px 24px;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    box-shadow: ${({ theme }) => theme.shadow.card};
  }
`
const Info = styled.div`
  display: flex;
  min-width: 240px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    flex-direction: row;
    min-width: 240px;
    align-items: center;
    align-content: center;
    justify-content: start;
    gap: 4px 16px;
    flex: 1 0 0;
    flex-wrap: wrap;
  }
`

const PlanContainer = styled.div`
  display: flex;
  height: 21px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 4px;
`
const DateContainer = styled(PlanContainer)``

const Text = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

export interface BalanceSubscriptionStatusProps {
  planName: string
  isActive: boolean
  date: string
  price: number
  onManageClick: () => void
}

export const BalanceSubscriptionStatus: FC<BalanceSubscriptionStatusProps> = (
  props,
) => {
  const { planName, isActive, price, date, onManageClick } = props
  const priceText = `$${price} / month`
  return (
    <Container>
      <Info>
        <PlanContainer>
          <Text>{planName}:</Text>
          <Text>{priceText}</Text>
        </PlanContainer>
        <DateContainer>
          <Text>{isActive ? 'Next payment:' : 'Active until:'}</Text>
          <Text>{dayjs(date).format(formatDate.formatDate1)}</Text>
        </DateContainer>
      </Info>
      <StyledPrimaryDottedButton onClick={onManageClick}>
        Manage Subscription
      </StyledPrimaryDottedButton>
    </Container>
  )
}
